import createPrintRequest from "./createPrintRequest"

import { store } from "@redux"
import moment from "./moment"

const printEditedOrder = (editedOrder) => {
  const {
    kitchenTitle,
    serviceTypeName
  } = store.getState().systemSettings

  const printers = store.getState().printers

  const printData = {
    kitchenTitle,
    serviceTypeName,
    tableNumber: editedOrder.tableNumber,
    orderId: editedOrder._id,
    date: moment().toISOString(),
    code: editedOrder.code,
    items: editedOrder.items
  }

  printers.forEach((printerSettings, printerIndex) => {
    const request = {
      printType: "orderEdited",
      printData,
      printerIndex,
      printerSettings,
      saveToFailedPrints: true
    }

    createPrintRequest(request)
  })
}

export default printEditedOrder